<template>
  <div :class="`box alert ${alertType}`">
    <div class="icon-container">
      <div :class="`icon ${alertType}`" />
    </div>
    <slot v-if="slotsFilled"></slot>
    <slot v-else name="errorMessage">
      <p v-if="isPlainText" v-html="message" class="error-message" />
      <div v-else v-html="message" class="error-message" />
    </slot>
  </div>
</template>

<script>
import { Comment, Text } from 'vue';
import { ErrorStrings } from '@general/js/constants';

export default {
  inheritAttrs: false,
  name: 'Alert',
  props: {
    message: {
      type: String,
      default: ErrorStrings.GENERIC_ERROR,
    },
    alertType: {
      type: String,
      default: 'info',
      validator(value) {
        // The alertType must be one of these
        return ['info', 'error', 'success'].includes(value);
      },
    },
    // For message, it can be a string or template
    isPlainText: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    slotsFilled() {
      const nodes = this.$slots.default?.() ?? [];
      return nodes.some((node) => node.type !== Comment && !(node.type === Text && String(node.children).trim() === ''));
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  &.alert {
    display: flex;
    color: $GREY_800;
    column-gap: 1rem;
    align-items: center;
    padding: 1.5rem;
    border-radius: $XS;
    margin: 1rem 0;

    &.info {
      background-color: $PRIMARY_SKY_20;
    }

    &.error {
      background-color: $FUNCTIONAL_WARNING_20;
    }

    &.success {
      background-color: $PRIMARY_BRIGHT_GREEN_20;
    }

    .icon-container {
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        height: $LG;
        width: $LG;
        mask-position: center;
        mask-repeat: no-repeat;

        &.info {
          background-color: $INFORMATIVE;
          -webkit-mask-image: url('/assets/public/images/info_icon.svg');
          mask-image: url('/assets/public/images/info_icon.svg');
        }

        &.error {
          background-color: $ERROR;
          -webkit-mask-image: url('/assets/public/images/icon_error.svg');
          mask-image: url('/assets/public/images/icon_error.svg');
        }

        &.success {
          background-color: $SUCCESS;
          -webkit-mask-image: url('/assets/public/images/icon_success.svg');
          mask-image: url('/assets/public/images/icon_success.svg');
        }
      }
    }

    :deep(p) {
      margin: 0;
    }

    .error-message {
      :deep(p) {
        margin: 0;
      }
    }
  }
}
</style>
